<app-breadcrumb [title]="'Edit Profile'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-header">{{title}}</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <form [formGroup]="profileForm" (ngSubmit)="submit()" novalidate>
                <input type="hidden" formControlName="id">
                <div class="form-group mb-3">
                  <label class="form-label" for="shalaId">Shala Darpan (PIS) ID</label>
                  <input type="text" class="form-control" MyInput placeholder="Shala Darpan (PIS) ID"
                    formControlName="shalaId" id="shalaId">
                  <my-error controlName="shalaId" errorKey="required">Shala Darpan (PIS) ID is required.</my-error>
                  <my-error controlName="shalaId" errorKey="pattern">Enter valid 10 Or 11 digit Shala Darpan (PIS) ID.</my-error>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="email">Your Email</label>
                  <input type="email" class="form-control" MyInput placeholder="Email" formControlName="email"
                    id="email">
                  <my-error controlName="email" errorKey="required">Email is required.</my-error>
                  <my-error controlName="email" errorKey="email">Please enter a valid email.</my-error>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="phoneNumber">Your Mobile</label>
                  <input type="text" class="form-control" MyInput placeholder="Mobile" formControlName="phoneNumber"
                    id="phoneNumber">
                  <my-error controlName="phoneNumber" errorKey="required">Mobile Number is required.</my-error>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3 form-check">
                    <input type="checkbox" MyInput formControlName="emailConfirmed" class="form-check-input"
                      id="emailConfirmed">
                    <label class="form-check-label" for="emailConfirmed">Email Confirm</label>
                  </div>
                </div>
                <div class="d-grid gap-2">
                  <button class="btn btn-primary" [disabled]="!profileForm.valid || loading" type="submit">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                      *ngIf="loading"></span>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
